import i18n from "i18next";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

const supported = ["fr", "en", "cn", "de", "es", "it", "ja", "ko", "pt"];

void i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: "fr",
    supportedLngs: supported,
    backend: {
      // Reuse the main app's locales, served at /locales/{lng}/translation.json by Firebase Hosting.
      // Production deploys put apps/qr-pwa/dist behind a different host, so ensure the locales
      // are also copied or served alongside (see vite.config.ts public dir or build pipeline).
      loadPath: "/locales/{{lng}}/translation.json",
    },
    react: { useSuspense: false },
    interpolation: { escapeValue: false },
    returnNull: false,
    // Une traduction vide ("") compte comme manquante : repli sur le français
    // (fallbackLng) au lieu d'un libellé blanc.
    returnEmptyString: false,
  });

export default i18n;
